import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';
import type { EditorRemixLifecycleObservation } from '@atlassian/malleable-ui-components/types';

const TAGS = ['remix', 'stateRearchitecture'];

/** Fires the bounded ownership-soak event without allowing analytics failures into product flow. */
export const dispatchEditorRemixLifecycleOwnershipEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	observation: EditorRemixLifecycleObservation,
): void => {
	try {
		const { actionSubjectId, producer, artifactType, sentinelSource, outcome, reason } =
			observation;
		createAnalyticsEvent({
			type: 'sendOperationalEvent',
			data: {
				action: 'observed',
				actionSubject: 'editorRemixLifecycleOwnership',
				actionSubjectId,
				source: 'editorRemix',
				tags: TAGS,
				attributes: {
					migrationPhase: 'ownership-soak',
					producer,
					artifactType,
					...(sentinelSource ? { sentinelSource } : {}),
					outcome,
					reason,
					...('phaseAtSettlement' in observation && observation.phaseAtSettlement
						? { phaseAtSettlement: observation.phaseAtSettlement }
						: {}),
					...('settlementTrigger' in observation && observation.settlementTrigger
						? { settlementTrigger: observation.settlementTrigger }
						: {}),
					...('blockingAttempt' in observation && observation.blockingAttempt
						? { blockingAttempt: observation.blockingAttempt }
						: {}),
				},
			},
		}).fire();
	} catch {
		// Observability must never affect Remix behavior.
	}
};
